import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../apiConfig';
import axios from 'axios';

const ERROR_MESSAGES = {
  POST_FAILURE: 'Failed to verify bank account',
  GET_FAILURE: 'Failed to fetch pre-onboarding data',
  CONSENT_FETCH_FAILURE: 'Failed to fetch consent data',
};

export const postOnBoardingFormThunk = createAsyncThunk(
  'postOnBoardingFormThunk',
  async ({ requestBody, jwtBearer }, { rejectWithValue }) => {
    console.log("Request Body:", requestBody);
    console.log("jwtBearer :", jwtBearer);
    try {
      const response = await axios.post(
        `${BASE_URL}onboarding/consent/form/`,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error Response: ", error);
      const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.';
      const errorCode = error?.response?.data?.code || 400;
      return rejectWithValue({
        code: errorCode,
        message: errorMessage
      });
    }
  }
);

// Thunk for getting onboarding data
// export const getOnBoardingDataThunk = createAsyncThunk(
//   'getOnBoardingDataThunk',
//   async ({ jwtBearer }) => {
//     console.log("jwtBearer--- :", jwtBearer);

//     try {
//       const response = await axios.get(`${BASE_URL}onboarding/data/`, {
//         headers: {
//           Authorization: `Bearer ${jwtBearer}`
//         }
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue({
//         errorMessage: error.response?.data?.message || ERROR_MESSAGES.GET_FAILURE,
//       });
//     }
//   }
// );

export const getOnBoardingDataThunk = createAsyncThunk(
  'getOnBoardingDataThunk',
  async ({ jwtBearer }, { rejectWithValue }) => {
    console.log("jwtBearer--- :", jwtBearer);

    try {
      const response = await axios.get(`${BASE_URL}onboarding/data/`, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      return rejectWithValue({
        errorMessage: error.response?.data?.message || ERROR_MESSAGES.GET_FAILURE,
      });
    }
  }
);


// New thunk for getting consent data
export const getConsentDataThunk = createAsyncThunk(
  'getConsentDataThunk',
  async ({ candidateId, jwtBearer }, { rejectWithValue }) => {
    console.log("jwtBearer :", jwtBearer);

    try {
      const response = await axios.get(`${BASE_URL}onboarding/consent/${candidateId}`, {
        headers: {
          'Authorization': `Bearer ${jwtBearer}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error.response?.data?.message || ERROR_MESSAGES.CONSENT_FETCH_FAILURE,
      });
    }
  }
);

export const verifyOtp = createAsyncThunk(
  'user/verifyOtp',
  async ({ number, otp, jwtBearer }, { rejectWithValue }) => {
    try {
      console.log("jwtBearer :", jwtBearer);

      const response = await axios.post(
        `${BASE_URL}onboarding/verify/otp/?number=${encodeURIComponent(number)}&otp=${encodeURIComponent(otp)}`,
        null,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtBearer}`
          }
        }
      );

      if (response.data && response.data.code === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data);
      } else if (error.request) {
        return rejectWithValue({ message: 'No response from server.' });
      } else {
        return rejectWithValue({ message: error.message });
      }
    }
  }
);

export const verifyPan = createAsyncThunk(
  'user/verifyPan',
  async ({ pan, jwtBearer }, { rejectWithValue }) => {
    console.log("jwtBearer :", jwtBearer);

    try {
      const timestamp = Date.now();
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwtBearer}`,
        'X-OFB-TOKEN': '887899419062573985',
        'accessKey': 'EV1AQX5HN17F',
        'signature': 'c8f53a9ec29d890f37a8c7c14b3bb364c35960ed4571904a62863cbb2458321f',
        'timestamp': timestamp.toString(),
      };

      const response = await axios.get(
        `${BASE_URL}onboarding/verifyPan?pan=${encodeURIComponent(pan)}`,
        { headers }
      );

      if (response.data && response.data.code === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data);
      } else if (error.request) {
        return rejectWithValue({ message: 'No response from server.' });
      } else {
        return rejectWithValue({ message: error.message });
      }
    }
  }
);

export const generateEmpBureau = createAsyncThunk(
  'generateEmpBureau',
  async ({ requestBody, jwtBearer }, { rejectWithValue }) => {
    console.log("Request Body:", requestBody);
    console.log("jwtBearer :", jwtBearer);

    try {
      const response = await axios.post(
        `${BASE_URL}onboarding/generate/bureau/`,
        requestBody,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtBearer}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error Response: ", error);
      const errorMessage = error?.response?.data?.message || 'An unexpected error occurred.';
      const errorCode = error?.response?.data?.code || 400;
      return rejectWithValue({
        code: errorCode,
        message: errorMessage
      });
    }
  }
);

// Initial state for the slice
const initialState = {
  preOnBoardingFormdata: null,
  onBoardingFormdata: null,
  consentData: null,
  isLoading: false,
  isError: null,
};

// Create the slice
const preOnBoardingSlice = createSlice({
  name: 'preOnBoardingSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postOnBoardingFormThunk.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(postOnBoardingFormThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.preOnBoardingFormdata = action.payload;
      })
      .addCase(postOnBoardingFormThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload?.errorMessage || ERROR_MESSAGES.POST_FAILURE;
      })

      .addCase(getOnBoardingDataThunk.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getOnBoardingDataThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.onBoardingFormdata = action.payload.data;
      })
      .addCase(getOnBoardingDataThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload?.errorMessage || ERROR_MESSAGES.GET_FAILURE;
      })

      .addCase(getConsentDataThunk.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(getConsentDataThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.consentData = action.payload;
      })
      .addCase(getConsentDataThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = action.payload?.errorMessage || ERROR_MESSAGES.CONSENT_FETCH_FAILURE;
      });
  },
});

// Exporting the reducer
export default preOnBoardingSlice.reducer;
